// The team form's shape — the create/edit drawer validates it. All fields are always
// present (input === output, useFormShell's constraint). Bounds match the backend
// request schema (name ≤ 64 — teams.name varchar(64)); never stricter (CONVENTIONS
// §Schemas). The clock is a switch — "works on the project's clock" — and a zone
// only when it is off: the wire stores NULL for the project's (ADR-082 §2).

import { z } from 'zod';

export const teamFormSchema = z
  .object({
    name: z.string().trim().min(1).max(64),
    project_clock: z.boolean(),
    timezone_iana: z.string().nullable(),
  })
  .refine((v) => v.project_clock || (v.timezone_iana !== null && v.timezone_iana.length > 0), { path: ['timezone_iana'], message: 'TIMEZONE_REQUIRED' });
export type TeamFormValues = z.infer<typeof teamFormSchema>;
